<template>
  <div class="addressBar">
    <span
      v-if="path && path.firSubName"
      @click="goFirSub()"
      @mouseover="changeColor"
      @mouseout="changeColor"
      class="pathItem"
    >{{ path.firSubName }}</span
    >
    <span v-if="path && path.secSubName"> > </span>
    <span
      v-if="path && path.secSubName"
      class="pathItem"
      @click="goSecSub(path.firSubId)"
      @mouseover="changeColor"
      @mouseout="changeColor"
    >
      {{ path.secSubName }}
    </span>
    <span v-if="path && path.courseName"> > </span>
    <span
      v-if="path && path.courseName"
      class="pathItem"
      @click="goCourse(path.courseId)"
      @mouseover="changeColor"
      @mouseout="changeColor"
    >
      {{ path.courseName }}
    </span>
    <span v-if="path && path.slidesName"> > </span>
    <span v-if="path && path.slidesName" class="pathItem">
      {{ path.slidesName }}
    </span>
  </div>
</template>

<script>
import { colorArrByIndex } from "@/utils/getColor.js";

export default {
  name: "addressBar", // 地址栏
  props: {
    // 地址对象
    path: {
      required: true,
      default: () => {}
    },
    categoryIndex: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      colorArrByIndex
    };
  },
  methods: {
    // 经过变色效果 颜色根据classNum获取
    changeColor(e) {
      if (this.$route.path === "/lookPPT" || this.$route.path === "/my") {
        if (!e.target.style.color) e.target.style.color = "#549AFF";
        else e.target.style.color = "";
      } else {
        const index = sessionStorage.getItem("classNum") || 0;
        const color = this.categoryIndex > 3 && index == 1 ? colorArrByIndex[0] : colorArrByIndex[index];

        if (!e.target.style.color) {
          e.target.style.color = color;
        } else {
          e.target.style.color = "";
        }
      }
    },
    // 跳转到一级
    goFirSub() {
      if (!this.path.secSubName) return;
      this.$router.push("/home");
    },
    // 跳转到二级
    goSecSub(id) {
      if (!this.path.courseName) return;
      this.$router.push({
        path: "/homeDetails",
        query: {
          id: id
        }
      });
    },
    goCourse(id) {
      if (!this.path.slidesName) return;
      this.$router.push({
        path: "/courseDetails",
        query: { id: id }
      });
    }
  }
};
</script>

<style lang="less" scoped>
.addressBar {
  height: 24px;
  line-height: 24px;
  font-size: 22px;
  color: #666;

  .pathItem {
    cursor: pointer;
  }

  .pathItem:last-child {
    font-weight: 600;
    color: #333;
  }
}
</style>
